import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import ChevronLeftIcon from '@atlaskit/icon/utility/chevron-left';
import { Flex, xcss } from '@atlaskit/primitives';
import messages from './messages';
var inPromptHeaderStyles = xcss({
  display: 'inline-flex',
  marginTop: 'space.negative.025',
  marginBottom: 'space.negative.025',
  // make room for the focus ring
  marginRight: 'space.050'
});
var toolTipProps = {
  position: 'top'
};
export var BackIconButton = function BackIconButton(_ref) {
  var inPromptHeader = _ref.inPromptHeader,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    stopPropagation = _ref.stopPropagation,
    onClick = _ref.onClick;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var onClickIconButton = useCallback(function (event) {
    if (stopPropagation) {
      event.stopPropagation();
    }
    onClick === null || onClick === void 0 || onClick();
  }, [stopPropagation, onClick]);
  var btn = /*#__PURE__*/React.createElement(IconButton, {
    isDisabled: isDisabled,
    appearance: "subtle",
    icon: ChevronLeftIcon,
    label: formatMessage(messages.backLabel),
    spacing: "compact",
    isTooltipDisabled: isDisabled,
    onClick: onClickIconButton,
    testId: "back-icon-button",
    tooltip: toolTipProps
  });
  if (inPromptHeader) {
    return /*#__PURE__*/React.createElement(Flex, {
      xcss: [inPromptHeaderStyles]
    }, btn);
  }
  return btn;
};